<div class="map-container">
  <google-map
    mapId="ddd9498ff818dc08"
    height="100%"
    width="100%"
    [options]="mapOptions"
    [center]="center()"
    [zoom]="zoom"
    (idle)="idle$.next()"
    (mapClick)="onMapClick($event)"
    (mapInitialized)="onMapReady($event)">
    <map-advanced-marker [position]="center()"
                         (mapClick)="clearSelection()"/>
  </google-map>
  <app-map-marker-details-carousel class="carousel" [locationsCampaignMap]="carrouselSectionLocationsCampaignMap"
                                   [campaignsUserStatus]="campaignUserStatus"
                                   [selectedLocation]="selectedLocation"
                                   (selectedLocationChange)="onSelectedCampaignChange($event)"
                                   [ngStyle]="{'visibility':this.store().campaigns().length > 0 && selectedLocation ? 'visible' : 'hidden'}"></app-map-marker-details-carousel>
</div>
